import { useSyncExternalStore } from 'react';
import { getIqUiSnapshot, subscribeIqUi } from '../../state/iqUiStore.ts';
import { IQ_DOM } from './iqDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function IqGameOver() {
  const d = IQ_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(subscribeIqUi, getIqUiSnapshot, getIqUiSnapshot);

  return (
    <div id={d.gameOverRoot} className="iq-gameover" hidden={!s.gameOverVisible}>
      <h2 className="iq-gameover__title">{t('game.game_over')}</h2>
      <div className="iq-gameover__score">{t('game.score')} {s.score}</div>
    </div>
  );
}
